export const styleSheet = theme => {
    const filterButton = {
        position: 'relative',
        overflow: 'hidden',
        height: 30,
        padding: '0 10px',
        borderRadius: 6,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        marginRight: 4,
        flexShrink: 0,
        p: {
            maxWidth: 120,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    };

    return {
        container: {
            position: 'relative',
            flex: 1,
            height: 30,
            minWidth: 6,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        dateRangePicker: {
            ...theme.content.hoverMenu,
            width: 350,
            height: 270,
            boxShadow: '0 6px 10px 0 rgba(0,0,0,0.2)',
            backgroundColor: theme.colors.white01
        },
        editIcon: {
            boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.1)',
            borderRadius: 4,
            height: 24,
            width: 23,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: 2,
            marginLeft: 4
        },
        scrollContainer: {
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 6,
            right: 6,
            display: 'flex',
            overflow: 'auto',
            scrollbarWidth: 'none',
            MsOverflowStyle: 'none',
            '::-webkit-scrollbar': {
                display: 'none',
                height: 0,
                width: 0
            },
            '::-webkit-scrollbar-thumb': {
                background: 'transparent',
                height: 0,
                display: 'none'
            }
        },
        scrollContainerWithArrows: {
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 30,
            right: 30,
            display: 'flex',
            overflow: 'auto',
            scrollbarWidth: 'none',
            MsOverflowStyle: 'none',
            '::-webkit-scrollbar': {
                display: 'none',
                height: 0,
                width: 0
            },
            '::-webkit-scrollbar-thumb': {
                background: 'transparent',
                height: 0,
                display: 'none'
            }
        },
        scrollArrowRight: {
            cursor: 'pointer',
            flexShrink: 0,
            width: 30,
            height: 30,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ':hover': {
                'svg g': {
                    fill: theme.colors.gray10
                }
            }
        },
        scrollArrowRightDisabled: {
            flexShrink: 0,
            width: 30,
            height: 30,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        scrollArrowLeft: {
            flexShrink: 0,
            cursor: 'pointer',
            width: 30,
            height: 30,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            svg: {
                transform: 'rotate(-180deg)'
            },
            ':hover': {
                'svg g': {
                    fill: theme.colors.gray10
                }
            }
        },
        scrollArrowLeftDisabled: {
            flexShrink: 0,
            width: 30,
            height: 30,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            svg: {
                transform: 'rotate(-180deg)'
            }
        },
        bookmarkTag: {
            ...filterButton,
            backgroundColor: theme.colors.blue15,
            boxShadow: `inset 0 0 0 1px ${theme.colors.blue08}`,
            color: theme.colors.white01,
            ':hover': {
                p: {
                    opacity: 0.5
                },
                '.removeIcon': {
                    display: 'flex',
                    'svg g': {
                        fill: '#c4bdf5'
                    }
                }
            },
            ':active': {
                boxShadow: 'inset 0 0 0 1px rgba(82, 76, 125, 1)',
                backgroundColor: 'rgba(82, 76, 125, 0.05)'
            }
        },
        eventGroup: {
            backgroundColor: '#ffb347'
        },
        equity: {
            ...filterButton,
            color: '#c4bdf5',
            boxShadow: 'inset 0 0 0 1px rgba(82, 76, 125, 1)',
            backgroundColor: 'rgba(82, 76, 125, 0.1)',
            ':hover': {
                backgroundColor: 'rgba(82, 76, 125, 0.2)',
                p: {
                    opacity: 0.5
                },
                '.removeIcon': {
                    display: 'flex',
                    'svg g': {
                        fill: '#c4bdf5'
                    }
                }
            },
            ':active': {
                boxShadow: 'inset 0 0 0 1px rgba(82, 76, 125, 1)',
                backgroundColor: 'rgba(82, 76, 125, 0.05)'
            }
        },
        index: {
            ...filterButton,
            color: '#e4ddb2',
            boxShadow: 'inset 0 0 0 1px rgba(169, 161, 111, 1)',
            backgroundColor: 'rgba(169, 161, 111, 0.1)',
            ':hover': {
                backgroundColor: 'rgba(169, 161, 111, 0.2)',
                p: {
                    opacity: 0.5
                },
                '.removeIcon': {
                    display: 'flex',
                    'svg g': {
                        fill: '#e4ddb2'
                    }
                }
            },
            ':active': {
                boxShadow: 'inset 0 0 0 1px rgba(169, 161, 111, 1)',
                backgroundColor: 'rgba(169, 161, 111, 0.05)'
            }
        },
        sector: {
            ...filterButton,
            color: '#e4ddb2',
            boxShadow: 'inset 0 0 0 1px rgba(169, 161, 111, 1)',
            backgroundColor: 'rgba(169, 161, 111, 0.1)',
            ':hover': {
                backgroundColor: 'rgba(169, 161, 111, 0.2)',
                p: {
                    opacity: 0.5
                },
                '.removeIcon': {
                    display: 'flex',
                    'svg g': {
                        fill: '#e4ddb2'
                    }
                }
            },
            ':active': {
                boxShadow: 'inset 0 0 0 1px rgba(169, 161, 111, 1)',
                backgroundColor: 'rgba(169, 161, 111, 0.05)'
            }
        },
        watchlist: {
            ...filterButton,
            color: '#b4e0d2',
            boxShadow: 'inset 0 0 0 1px rgba(76, 124, 109, 1)',
            backgroundColor: 'rgba(76, 124, 109, 0.1)',
            ':hover': {
                backgroundColor: 'rgba(76, 124, 109, 0.2)',
                p: {
                    opacity: 0.5
                },
                '.removeIcon': {
                    display: 'flex',
                    'svg g': {
                        fill: '#b4e0d2'
                    }
                }
            },
            ':active': {
                boxShadow: 'inset 0 0 0 1px rgba(76, 124, 109, 1)',
                backgroundColor: 'rgba(76, 124, 109, 0.05)'
            }
        },
        dateRange: {
            ...filterButton,
            padding: '0  10px 0 0',
            color: '#efcac8',
            boxShadow: 'inset 0 0 0 1px rgba(169, 115, 111, 1)',
            backgroundColor: 'rgba(169, 115, 111, 0.1)',
            p: {
                maxWidth: 170,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            },
            ':hover': {
                backgroundColor: 'rgba(169, 115, 111, 0.2)',
                p: {
                    opacity: 0.5
                },
                '.removeIcon': {
                    display: 'flex',
                    'svg g': {
                        fill: '#efcac8'
                    },
                    ':hover': {
                        'svg g': {
                            fill: '#fff'
                        }
                    },
                    ':active': {
                        'svg g': {
                            fill: '#efcac8'
                        }
                    }
                }
            },
            ':active': {
                boxShadow: 'inset 0 0 0 1px rgba(169, 115, 111, 1)',
                backgroundColor: 'rgba(169, 115, 111, 0.05)'
            }
        },
        removeIcon: {
            boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.1)',
            display: 'none',
            position: 'absolute',
            top: 0,
            right: 0,
            height: '100%',
            width: 28,
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '0 6px 6px 0',
            svg: {
                borderRadius: 7,
                height: 14,
                width: 14
            }
        }
    };
};
